export default __webpack_public_path__ + "static/media/Union (3).7161cbb7.svg";